<template>
  <div id="ongoing" class="tab-pane active tab-box">
    <div class="orders-lst skelton" v-if="is_skel_loader">
      <a href="javascript:void(0);">
        <div class="order-item d-flex align-items-start">
          <div class="img-cls">
            <skeleton-loader-vue
              width="85px"
              height="85px"
              style="border-radius: 5px"
            />
          </div>
          <div
            class="order-data ml-3 d-flex align-items-start justify-content-between w-100"
          >
            <div class="orders-status-main delivery-link">
              <h6 class="mb-1">
                <skeleton-loader-vue
                  type="string"
                  width="130px"
                  height="20px"
                />
              </h6>
              <skeleton-loader-vue type="string" width="50px" height="20px" />
              <p class="mt-2">
                <skeleton-loader-vue
                  type="string"
                  width="100px"
                  height="20px"
                />
              </p>
            </div>
            <div class="order-status">
              <p class="order-status-btn">
                <skeleton-loader-vue
                  type="circle"
                  width="100px"
                  height="20px"
                  style="border-radius: 20px !important"
                />
              </p>
            </div>
          </div>
        </div>
      </a>
    </div>
    <div class="orders-lst" v-if="ongoingorders.length > 0 && !is_skel_loader">
      <router-link
        v-for="(order, index) in ongoingorders"
        :key="index"
        :to="{
          name: 'order-status',
          params: { order_id: base64_encode(order.id) },
        }"
      >
        <div class="order-item d-flex align-items-start on-going-list-uniq">
          <div class="img-cls resimg-squre">
            <img :src="order.icon_image" />
          </div>
          <div
            class="order-data ml-3 d-flex align-items-start justify-content-between w-100"
          >
            <div class="orders-status-main delivery-link on-going-order">
              <h6 class="mb-1">{{ order.restaurant_name }}</h6>
              <!-- <span>{{parseFloat(order.total_amount || 0).toFixed(2)}}</span> -->

              <div class="">
                <div class="mt-1">
                  <span v-html="$auth.setting.currency" class="currency"></span>
                  <span>{{ order.total_amount }}</span>
                </div>
                <p class="orderid mt-1">{{ $t("Order") }} #{{ order.id }}</p>
                <div>
                  <p class="mt-1">
                    {{ moment(order.order_date).format("Do MMM YYYY hh:mm A") }}
                  </p>
                </div>
              </div>
            </div>
            <div class="order-status" v-if="order.order_status == 'Placed'">
              <p class="readytoserve order-status-btn">{{ $t("Placed") }}</p>
            </div>
            <div
              class="order-status"
              v-else-if="order.order_status == 'InKitchen'"
            >
              <p class="readytoserve order-status-btn">
                {{ $t("Processing") }}
              </p>
            </div>
            <div
              class="order-status"
              v-else-if="order.order_status == 'ReadyToServe'"
            >
              <p class="readytoserve order-status-btn">
                {{ $t("Food Ready") }}
              </p>
            </div>
            <div
              class="order-status"
              v-else-if="order.order_status == 'OnTheWay'"
            >
              <p class="readytoserve order-status-btn">
                {{ $t("On The Way") }}
              </p>
            </div>
            <div
              class="order-status"
              v-else-if="order.order_status == 'Arrived'"
            >
              <p class="readytoserve order-status-btn">{{ $t("Arrived") }}</p>
            </div>
            <div
              class="order-status"
              v-else-if="order.order_status == 'Delivered'"
            >
              <p class="delivered order-status-btn">{{ order.order_status }}</p>
            </div>
            <div
              class="order-status"
              v-else-if="order.order_status == 'Cancelled'"
            >
              <p class="canceled order-status-btn">{{ order.order_status }}</p>
            </div>
          </div>
        </div>
      </router-link>
    </div>
    <div v-else-if="!is_skel_loader && ongoingorders.length <= 0" class="order-offers">
      <p class="text-center ml-1">{{ $t("No Ongoing Order Found") }}</p>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import moment from "moment";
import VueSkeletonLoader from "skeleton-loader-vue";

export default {
  props: ["selectTab"],
  components: { "skeleton-loader-vue": VueSkeletonLoader },
  computed: {
    ...mapGetters("order", ["onGoingOrders"]),
  },
  data() {
    return {
      ongoingorders: [],
      moment: moment,
      is_skel_loader: true,
      isStopCallingApi: false,
      firstApiCall: true,
      skip: 0,
    };
  },
  mounted() {
    if (this.selectTab == "0") {
      this.OnGoingOrders();
    }
  },
  methods: {
    ...mapActions("order", ["newOrderListData"]),

    OnGoingOrders() {
      this.is_skel_loader = true;
      this.newOrderListData({
        vendor_id: this.$auth.getVendorId(),
        is_langauge: this.$store.state.lang.locale,
        user_id: this.$auth.user.user_id,
        total_record: "100",
        skip: this.skip,
      }).then((data) => {
        if (data.code == 200) {
          this.skip = this.skip + 100;
          this.is_skel_loader = false;
          data.Result.reverse().forEach((ele) => {
            if (
              ele.order_status != "Delivered" &&
              ele.order_status != "Cancelled" &&
              ele.order_status != "Refund" 
            ) {
              this.ongoingorders.push(ele);
            }
          });
          // let allData = data.Result;
          // if (!this.ongoingorders.length) {
          //   allData.forEach((resOrder) => {
          //     this.ongoingorders.push(resOrder);
          //   });
          // } else {
          //   allData.forEach((resOrder) => {
          //     let checkRest = this.ongoingorders.find((elm) => elm.id == resOrder.id);
          //     if (!checkRest) {
          //       this.ongoingorders.push(resOrder);
          //     }
          //   });
          // }
        } else {
          this.is_skel_loader = false;
        }

        this.ongoingorders.sort((a, b) => b.id - a.id)
      });
    },
  },
};
</script>
